import { z } from "zod";
import { ValidatorInterface } from "../validator-interface";

export class RequiredValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const labelText = options.labelText || "This field";
        const message = options.message || `${labelText} is required`;

        // Handle different base schema types
        if (baseSchema instanceof z.ZodString) {
            // Use min(1) for strings to check for non-empty
            return baseSchema.min(1, { message });
        } else if (baseSchema instanceof z.ZodNumber) {
            // For numbers, just ensure it's provided (non-NaN is handled by transform)
            // Zod's required() is implicit for non-optional schemas
            // We rely on the base type not being optional here.
            // If we need to explicitly forbid undefined/null for non-strings, refine is better.
            return baseSchema.refine(val => val !== undefined && val !== null, { message });
        } else if (baseSchema instanceof z.ZodBoolean) {
            // Ensure boolean is true if required (adjust logic as needed)
            return baseSchema.refine(val => val === true, { message });
        } else if (baseSchema instanceof z.ZodArray) {
            // Ensure array is not empty
            return baseSchema.nonempty({ message });
        }
        // Add more types as needed (e.g., ZodDate)

        // Default fallback: refine check for non-null/undefined
        // This might be too broad, consider specific type handling above
        return baseSchema.refine(val => val !== undefined && val !== null, { message });
    }

    getErrorMessage(field, options = {}) {
        const labelText = options.labelText || "This field";
        return options.message || `${labelText} is required`;
    }
}
